import { useMemo } from 'react';

const ALLOWED_LINK_PROTOCOLS = ['http:', 'https:', 'mailto:'];

type SafeLinkProps = {
  attributes: Record<string, unknown>;
  children: React.ReactNode;
  href: string;
};

const SafeLink = ({ children, href, attributes }: SafeLinkProps) => {
  const safeHref = useMemo(() => {
    let parsedUrl: URL | null = null;
    try {
      parsedUrl = new URL(href);
      // eslint-disable-next-line no-empty
    } catch {}
    if (parsedUrl && ALLOWED_LINK_PROTOCOLS.includes(parsedUrl.protocol)) {
      return parsedUrl.href;
    }
    return 'about:blank';
  }, [href]);

  return (
    <a href={safeHref} {...attributes}>
      {children}
    </a>
  );
};

export default SafeLink;
